import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import * as S from '../GraciasPage.styles';

/**
 * Botón de WhatsApp reutilizable
 * @param {string} href - URL del enlace de WhatsApp
 * @param {string} label - Etiqueta del botón (opcional, por defecto "WhatsApp")
 */
const WhatsAppButton = ({ href, label = 'WhatsApp' }) => {
  return (
    <S.WhatsAppButton 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
    >
      <FaWhatsapp />
      <span>{label}</span>
    </S.WhatsAppButton>
  );
};

export default WhatsAppButton;

